declare global {
  interface Window {
    settings: any;
  }
}

const EngineCompartmentSettings = window.settings;

export default EngineCompartmentSettings;